module.exports = __webpack_public_path__ + "static/faq-banner-95fe17e5274a9aee0002cab1bd386141.png";